import { BCDataGrid, BCTreeList } from '@bimser/components';
import DataGrid2 from '../..';
import { ICellPreparedEventArgs } from '../../../../entities/EventArgs';

export function onCellPrepared(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.CellPreparedEvent
		| BCTreeList.Components.TreeListTypes.CellPreparedEvent
) {
	if (e.rowType === 'data' && e.data[e.column.dataField]) {
		const cellPreparedArgs: ICellPreparedEventArgs = {
			data: e.data,
			column: this.__retrieveDataGridInstance().__getBCColumn(e.column.dataField) as any, // TODO:DATAGRID
			cellElement: e.cellElement
		};

		this.emit('event:OnCellPrepared', cellPreparedArgs);
	}
}
